import {
  isNumberiramasdbon0i as isNumber,
  isArray1hxjqtqy632bc as isArray,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
  isCharArray21auq5hbrg68m as isCharArray,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isShortArraywz30zxwtqi8h as isShortArray,
  isIntArrayeijsubfngq38 as isIntArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
} from '../../../js/typeCheckUtils.mjs';
import {
  PrimitiveKClassImpl1fv46nzfav2pd as PrimitiveKClassImpl,
  NothingKClassImpl_getInstancewy0n2btt0p4s as NothingKClassImpl_getInstance,
} from './KClassImpl.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_functionClasses() {
  _init_properties_primitives_kt__3fums4();
  return functionClasses;
}
var functionClasses;
function PrimitiveClasses$anyClass$lambda(it) {
  return !(it == null);
}
function PrimitiveClasses$numberClass$lambda(it) {
  return isNumber(it);
}
function PrimitiveClasses$booleanClass$lambda(it) {
  return !(it == null) ? typeof it === 'boolean' : false;
}
function PrimitiveClasses$byteClass$lambda(it) {
  return !(it == null) ? typeof it === 'number' : false;
}
function PrimitiveClasses$shortClass$lambda(it) {
  return !(it == null) ? typeof it === 'number' : false;
}
function PrimitiveClasses$intClass$lambda(it) {
  return !(it == null) ? typeof it === 'number' : false;
}
function PrimitiveClasses$longClass$lambda(it) {
  return !(it == null) ? typeof it === 'bigint' : false;
}
function PrimitiveClasses$floatClass$lambda(it) {
  return !(it == null) ? typeof it === 'number' : false;
}
function PrimitiveClasses$doubleClass$lambda(it) {
  return !(it == null) ? typeof it === 'number' : false;
}
function PrimitiveClasses$arrayClass$lambda(it) {
  return !(it == null) ? isArray(it) : false;
}
function PrimitiveClasses$stringClass$lambda(it) {
  return !(it == null) ? typeof it === 'string' : false;
}
function PrimitiveClasses$throwableClass$lambda(it) {
  return it instanceof Error;
}
function PrimitiveClasses$booleanArrayClass$lambda(it) {
  return !(it == null) ? isBooleanArray(it) : false;
}
function PrimitiveClasses$charArrayClass$lambda(it) {
  return !(it == null) ? isCharArray(it) : false;
}
function PrimitiveClasses$byteArrayClass$lambda(it) {
  return !(it == null) ? isByteArray(it) : false;
}
function PrimitiveClasses$shortArrayClass$lambda(it) {
  return !(it == null) ? isShortArray(it) : false;
}
function PrimitiveClasses$intArrayClass$lambda(it) {
  return !(it == null) ? isIntArray(it) : false;
}
function PrimitiveClasses$floatArrayClass$lambda(it) {
  return !(it == null) ? isFloatArray(it) : false;
}
function PrimitiveClasses$doubleArrayClass$lambda(it) {
  return !(it == null) ? isDoubleArray(it) : false;
}
var PrimitiveClassesClass;
function PrimitiveClasses() {
  if (PrimitiveClassesClass === VOID) {
    class $ {
      constructor() {
        PrimitiveClasses_instance = this;
        var tmp = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_0 = Object;
        tmp.anyClass = new (PrimitiveKClassImpl())(tmp_0, 'Any', PrimitiveClasses$anyClass$lambda);
        var tmp_1 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_2 = Number;
        tmp_1.numberClass = new (PrimitiveKClassImpl())(tmp_2, 'Number', PrimitiveClasses$numberClass$lambda);
        this.nothingClass = NothingKClassImpl_getInstance();
        var tmp_3 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_4 = Boolean;
        tmp_3.booleanClass = new (PrimitiveKClassImpl())(tmp_4, 'Boolean', PrimitiveClasses$booleanClass$lambda);
        var tmp_5 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_6 = Number;
        tmp_5.byteClass = new (PrimitiveKClassImpl())(tmp_6, 'Byte', PrimitiveClasses$byteClass$lambda);
        var tmp_7 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_8 = Number;
        tmp_7.shortClass = new (PrimitiveKClassImpl())(tmp_8, 'Short', PrimitiveClasses$shortClass$lambda);
        var tmp_9 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_10 = Number;
        tmp_9.intClass = new (PrimitiveKClassImpl())(tmp_10, 'Int', PrimitiveClasses$intClass$lambda);
        var tmp_11 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_12 = typeof BigInt === 'undefined' ? VOID : BigInt;
        tmp_11.longClass = new (PrimitiveKClassImpl())(tmp_12, 'Long', PrimitiveClasses$longClass$lambda);
        var tmp_13 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_14 = Number;
        tmp_13.floatClass = new (PrimitiveKClassImpl())(tmp_14, 'Float', PrimitiveClasses$floatClass$lambda);
        var tmp_15 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_16 = Number;
        tmp_15.doubleClass = new (PrimitiveKClassImpl())(tmp_16, 'Double', PrimitiveClasses$doubleClass$lambda);
        var tmp_17 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_18 = Array;
        tmp_17.arrayClass = new (PrimitiveKClassImpl())(tmp_18, 'Array', PrimitiveClasses$arrayClass$lambda);
        var tmp_19 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_20 = String;
        tmp_19.stringClass = new (PrimitiveKClassImpl())(tmp_20, 'String', PrimitiveClasses$stringClass$lambda);
        var tmp_21 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_22 = Error;
        tmp_21.throwableClass = new (PrimitiveKClassImpl())(tmp_22, 'Throwable', PrimitiveClasses$throwableClass$lambda);
        var tmp_23 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_24 = Array;
        tmp_23.booleanArrayClass = new (PrimitiveKClassImpl())(tmp_24, 'BooleanArray', PrimitiveClasses$booleanArrayClass$lambda);
        var tmp_25 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_26 = Uint16Array;
        tmp_25.charArrayClass = new (PrimitiveKClassImpl())(tmp_26, 'CharArray', PrimitiveClasses$charArrayClass$lambda);
        var tmp_27 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_28 = Int8Array;
        tmp_27.byteArrayClass = new (PrimitiveKClassImpl())(tmp_28, 'ByteArray', PrimitiveClasses$byteArrayClass$lambda);
        var tmp_29 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_30 = Int16Array;
        tmp_29.shortArrayClass = new (PrimitiveKClassImpl())(tmp_30, 'ShortArray', PrimitiveClasses$shortArrayClass$lambda);
        var tmp_31 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_32 = Int32Array;
        tmp_31.intArrayClass = new (PrimitiveKClassImpl())(tmp_32, 'IntArray', PrimitiveClasses$intArrayClass$lambda);
        var tmp_33 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_34 = Float32Array;
        tmp_33.floatArrayClass = new (PrimitiveKClassImpl())(tmp_34, 'FloatArray', PrimitiveClasses$floatArrayClass$lambda);
        var tmp_35 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_36 = Float64Array;
        tmp_35.doubleArrayClass = new (PrimitiveKClassImpl())(tmp_36, 'DoubleArray', PrimitiveClasses$doubleArrayClass$lambda);
      }
      rf() {
        return this.anyClass;
      }
      sf() {
        return this.numberClass;
      }
      tf() {
        return this.nothingClass;
      }
      uf() {
        return this.booleanClass;
      }
      vf() {
        return this.byteClass;
      }
      wf() {
        return this.shortClass;
      }
      xf() {
        return this.intClass;
      }
      yf() {
        return this.longClass;
      }
      zf() {
        return this.floatClass;
      }
      ag() {
        return this.doubleClass;
      }
      bg() {
        return this.arrayClass;
      }
      cg() {
        return this.stringClass;
      }
      dg() {
        return this.throwableClass;
      }
      eg() {
        return this.booleanArrayClass;
      }
      fg() {
        return this.charArrayClass;
      }
      gg() {
        return this.byteArrayClass;
      }
      hg() {
        return this.shortArrayClass;
      }
      ig() {
        return this.intArrayClass;
      }
      jg() {
        return this.floatArrayClass;
      }
      kg() {
        return this.doubleArrayClass;
      }
      functionClass(arity) {
        var tmp0_elvis_lhs = get_functionClasses()[arity];
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp_0 = Function;
          var tmp_1 = 'Function' + arity;
          var result = new (PrimitiveKClassImpl())(tmp_0, tmp_1, (it) => {
            var tmp;
            if (typeof it === 'function') {
              // Inline function 'kotlin.js.asDynamic' call
              tmp = it.length === arity;
            } else {
              tmp = false;
            }
            return tmp;
          });
          // Inline function 'kotlin.js.asDynamic' call
          get_functionClasses()[arity] = result;
          tmp = result;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForObject($, 'PrimitiveClasses');
    PrimitiveClassesClass = $;
  }
  return PrimitiveClassesClass;
}
var PrimitiveClasses_instance;
function PrimitiveClasses_getInstance() {
  if (PrimitiveClasses_instance === VOID)
    new (PrimitiveClasses())();
  return PrimitiveClasses_instance;
}
var properties_initialized_primitives_kt_jle18u;
function _init_properties_primitives_kt__3fums4() {
  if (!properties_initialized_primitives_kt_jle18u) {
    properties_initialized_primitives_kt_jle18u = true;
    // Inline function 'kotlin.arrayOfNulls' call
    functionClasses = Array(0);
  }
}
//region block: exports
export {
  PrimitiveClasses_getInstance as PrimitiveClasses_getInstanceds06xwqrwfdm,
};
//endregion

//# sourceMappingURL=primitives.mjs.map
